export default __webpack_public_path__ + "20cacbe78ac468e71a01197dbc21205b.woff";